import React, { useEffect, useState }  from 'react';
import { useParams, useLocation } from 'react-router-dom';
import './ProductARViewer.css';
import { getBaseURL, getUSDZBaseURL, getGLBBaseURL, getUSDZAIBaseURL, getGLBAIBaseURL } from '../env';

const decodeModelPath = (encodedModel) => {
  const normalizedModel = encodedModel
    .replace(/ /g, '+')
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  const paddedModel = normalizedModel.padEnd(
    normalizedModel.length + (4 - normalizedModel.length % 4) % 4,
    '='
  );
  const decodedBytes = Uint8Array.from(atob(paddedModel), character => character.charCodeAt(0));

  return new TextDecoder().decode(decodedBytes).trim();
};

const resolveModelUrl = (encodedModel, baseUrl) => {
  const modelPath = decodeModelPath(encodedModel);

  if (/^https?:\/\//i.test(modelPath)) {
    return modelPath;
  }

  return `${baseUrl}${modelPath.replace(/^\/+/, '')}`;
};

const ProductARViewer = () => {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const platformQuery = queryParams.get('platform');
  const environmentQuery = queryParams.get('env');
  const aiQuery = queryParams.get('ai');
  const modelQuery = queryParams.get('model');
  const platform = platformQuery ? platformQuery : "aws";
  const env = environmentQuery ? environmentQuery : "staging";
  const isAIModel = aiQuery ? aiQuery : undefined;
  const [isLoading, setIsLoading] = useState(true);
  const [id, setId] = useState(null);

  useEffect(() => {
    const path = window.location.pathname;
    setId(path.split('/').pop());
  }, []);

  const getUSDZUrl = () => {
    let link= ''
    if (isAIModel) {  
      link = getUSDZAIBaseURL(platform, env) + id + '.usdz';
    }
    else {
      link = getUSDZBaseURL(platform, env) + id + '.usdz';
    }
    return link;
  };

  const getGlbUrl = () => {
    if (modelQuery) {
      try {
        const baseUrl = getBaseURL(platform, env);
        return resolveModelUrl(modelQuery, baseUrl);
      } catch {
        // Fall back to the product ID path when the model query is invalid.
      }
    }

    let link= ''
    if (isAIModel) {
      link = getGLBAIBaseURL(platform, env) + id + '.glb';
    }
    else {
      link = getGLBBaseURL(platform, env) + id + '.glb';
    }
    return link;
  };

const getAndroidZUrl = () => {
    return `intent://arvr.google.com/scene-viewer/1.0?file=${getGlbUrl()}&mode=ar_only#Intent;scheme=https;package=com.google.android.googlequicksearchbox;end;`;
}

  const openAr = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/iPhone|iPad|iPod/i.test(userAgent)) {
          window.location.href = getUSDZUrl(); 
        }
        else if (/android/i.test(userAgent)) {
            window.location.href = getAndroidZUrl();   
        }
        else {
            window.location.href = getAndroidZUrl();
        }
    };

  useEffect(() => {
    if (id) {
      openAr();
    }
  }, [id]);

  return (
    <>
      <div className="ar-loader-container">
        {isLoading && (
          <div className="loading-text">
            <div>Loading AR Experience</div>
            <div className="loading-dots">
              <span className="dot-1">•</span>
              <span className="dot-2">•</span>
              <span className="dot-3">•</span>
              <span className="dot-4">•</span>
            </div>
          </div>
        )}
        <div className="ar-viewer-title">
          <span>
            <img 
              src="/img/ar.png" 
              alt="AR" 
              className="ar-icon"
            />
            ALL3D AR Viewer
          </span>
        </div>
      </div>
    </>
  );
};

export default ProductARViewer;
